import { styleTags, tags as t } from '@lezer/highlight'

const twigHighlight = styleTags({
    "if endif": t.controlKeyword,
    "elseif": t.controlKeyword, // Highlight `elseif`
    "{{ }} {% %}": t.meta,
    "for endfor": t.controlKeyword, // Highlight `for` and `endfor`
    DirectiveContent: t.variableName,
    Operator: t.operator // Highlight operators
});

export { twigHighlight }
